// initial state
const getDefaultState = () => {
  return {
    isActive: false,
    basicInfo: {
      fName: null,
      lName: null,
      email: null,
      phone: null,
      company: null,
      productInterest: {
        ties: false,
        bowTies: false,
        pocketSquares: false,
        infinityScarves: false,
        chiffonScares: false
      },
      deadline: null,
      adSource: null,
      segment: "organization",
      saved: false
    },
    selectedStyles: {
      styles: [],
      custom: "",
      saved: false
    },
    uploadedFiles: {
      files: [],
      saved: false
    },
    colors: {
      primary: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      secondary: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      accent1: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      accent2: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      },
      accent3: {
        colorName: "",
        hex: "#dddddd",
        colorSet: ""
      }
    }
  };
};

const state = getDefaultState();

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  increment: state => state.count++,
  decrement: state => state.count--,
  setColors(state, color) {
    state.colors[color.selection] = color;
  },
  clearColor(state, placement) {
    state.colors[placement] = {
      colorName: "",
      hex: "#dddddd",
      colorSet: ""
    };
  },
  setBasicInfo(state, info) {
    state.basicInfo = info;
    state.basicInfo.saved = true;
    state.isActive = true;
  },
  setSelectedStyles(state, styles) {
    state.selectedStyles.styles = styles;
    state.selectedStyles.saved = true;
  },
  setCustomRequest(state, request) {
    state.selectedStyles.custom = request;
    state.selectedStyles.saved = true;
  },
  setUploadedFiles(state, files) {
    state.uploadedFiles.files = files;
    state.uploadedFiles.saved = true;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/newOrgProject.js